module.exports = __webpack_public_path__ + "img/14.8ea2a443.jpg";